<div class="menu-item-label" #label>
  @if (!!icon && !loading) {
  <av-icon size="xs" [name]="icon"></av-icon>
  } @if (loading) {
  <av-spinner size="xs"></av-spinner>
  }
  <span role="text" avOverflowDetect>
    <ng-content></ng-content>
  </span>
</div>
@if (!!info) {
<div class="menu-item-info">
  <av-tooltip position="left" [message]="info" [detached]="true">
    <span class="info">i</span>
  </av-tooltip>
</div>
} @if (postfix) {
<div class="menu-item-postfix text-muted">
  <small>{{ postfix }}</small>
</div>
} @if (arrow) {
<div>
  <div class="menu-item-chevron" #arrow></div>
</div>
}
<!-- [class.menu-item-submenu-visible]="isSubMenuVisible()" -->
<div
  #submenu
  class="menu-item-submenu"
  [class.menu-item-submenu-left]="subMenuPosition()?.placement === 'left'"
  [style.left.px]="
    subMenuPosition()?.placement === 'overlay'
      ? subMenuPosition().offsetX
      : null
  "
  [style.transform]="subMenuTransform"
>
  <ng-content select="[sub-menu]"></ng-content>
</div>
